import API_BASE_URL from "../config";

export const getUserRole = () => {
    const token = localStorage.getItem("token");
    if (!token) return null;

    try {
        const payload = JSON.parse(atob(token.split(".")[1])); // JWT dekódolása
        return payload["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"]; // ✅ Felhasználó szerepköre
    } catch (error) {
        console.error("❌ Hiba a token dekódolásakor:", error);
        return null;
    }
};

export const getUserId = () => {
    const token = localStorage.getItem("token");
    if (!token) return null;

    try {
        const payload = JSON.parse(atob(token.split(".")[1])); // JWT dekódolása
        return payload.sub; // ✅ Felhasználó ID-ja
    } catch (error) {
        console.error("❌ Hiba a token dekódolásakor:", error);
        return null;
    }
};

export const getUserData = async () => {
    const token = localStorage.getItem("token");
    if (!token) return null;

    try {
        const response = await fetch(`${API_BASE_URL}/api/users/me`, {
            headers: { Authorization: `Bearer ${token}` },
        });

        if (!response.ok) {
            throw new Error("Failed to fetch user data");
        }

        return await response.json(); // ✅ Visszaadja a teljes user objektumot
    } catch (error) {
        console.error("❌ Hiba a felhasználói adatok lekérésekor:", error);
        return null;
    }
};
